import { IMeasurementType, type IRatingMatrixFrameworkParameter, type IRatingMatrixFrameworkSubParameter } from '__generated__';
import { weightFractionToPercent } from 'services/rating-matrix-framework-parameter';

export const MEASUREMENT_QUANTITATIVE = IMeasurementType.Value0;
export const MEASUREMENT_QUALITATIVE = IMeasurementType.Value1;
export const MEASUREMENT_DIRECT = IMeasurementType.Value2;
export const MEASUREMENT_DERIVED = IMeasurementType.Value3;

export function buildSubParameterFilter(parameterId: number): string {
  return `parameterID==${parameterId}`;
}

export function buildSubParametersForTemplateFilter(parameterIds: number[]): string | null {
  if (parameterIds.length === 0) {
    return null;
  }

  return parameterIds.map((id) => `parameterID==${id}`).join('||');
}

export function isQuantitative(type: IMeasurementType | null | undefined): boolean {
  return type === MEASUREMENT_QUANTITATIVE;
}

export function isQualitative(type: IMeasurementType | null | undefined): boolean {
  return type === MEASUREMENT_QUALITATIVE;
}

export function isDirectScore(type: IMeasurementType | null | undefined): boolean {
  return type === MEASUREMENT_DIRECT;
}

export function isDerived(type: IMeasurementType | null | undefined): boolean {
  return type === MEASUREMENT_DERIVED;
}

export function getNextSubSortOrder(subs: IRatingMatrixFrameworkSubParameter[]): number {
  if (subs.length === 0) {
    return 1;
  }

  return Math.max(...subs.map((sub) => sub.sortOrder)) + 1;
}

/** Sum of sibling sub weights (%) after excluding the deleted sub. */
export function computeSubDeleteWeightTotal(
  parameter: IRatingMatrixFrameworkParameter,
  excludeSubId: number,
): number {
  const subs = parameter.subParameters ?? [];
  return weightFractionToPercent(
    subs
      .filter((sub) => sub.id !== excludeSubId)
      .reduce((sum, sub) => sum + (sub.weight ?? 0), 0),
  );
}
